import { Vue, Component } from 'vue-property-decorator';

@Component
export default class WindowSizeMixin extends Vue {
  protected windowWidth: number = typeof window !== 'undefined' ? window.innerWidth : 1024;

  mounted() {
    window.addEventListener('resize', this.onWindowResize);
  }

  beforeDestroy() {
    window.removeEventListener('resize', this.onWindowResize);
  }

  protected onWindowResize() {
    this.windowWidth = window.innerWidth;
  }
}
